import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.428 3.514a4.16 4.16 0 0 0-5.826-.057L3.228 14.394A4 4 0 0 0 2 17.277v3.194a1 1 0 0 0 1 1h3.262a4 4 0 0 0 2.773-1.117l11.335-10.9a4.16 4.16 0 0 0 .058-5.94m-4.44 1.384a2.16 2.16 0 0 1 2.996 3.115l-.808.776-3.056-3.056zm-2.31 2.222-9.064 8.716A2 2 0 0 0 4 17.277v2.194h2.262a2 2 0 0 0 1.386-.559l9.087-8.736z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }